import { RosterAbilityV2 } from '@wwe-portal/ui/features/roster';
import { useSuperstarDetailContext } from './context';
import { MAX_NUMBER_OF_ABILITIES } from '@wwe-portal/web/utils/superstar-details/constants';
import {
  CommonDialogContentLayout,
  createPortableDialog,
  Dialog,
  DialogContent,
  showDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { extractLocalAbilityId } from '@wwe-portal/web/utils/superstar-details/extractor';

const MaxAbilitiesReached = createPortableDialog(() => {
  const modal = usePortableDialog();
  return (
    <Dialog open={modal.visible} onOpenChange={modal.remove}>
      <DialogContent variant="message">
        <CommonDialogContentLayout
          closable
          descriptionElement="You can only equip up to 3 abilities, please unequip one to equip a new ability."
          imageElement={null}
          titleElement="Max Abilities Reached"
          onClose={modal.remove}
        />
      </DialogContent>
    </Dialog>
  );
});

export const AbilitiesConsumer = () => {
  const t = useTranslations();
  const abilities = useSuperstarDetailContext(
    (state) => state.currentStats.selectedAbilities
  );

  const getEquipLabel = ({
    equipped,
    canEquip,
  }: {
    equipped: boolean;
    canEquip: boolean;
  }) => {
    if (equipped) return t('superstar-details.abilities.equipped');
    if (canEquip) return t('superstar-details.abilities.readyToEquip');
    return t('superstar-details.abilities.unavailable');
  };

  const changeAbility = useSuperstarDetailContext(
    (state) => state.changeAbility
  );

  const baseStats = useSuperstarDetailContext((state) => state.baseStats);

  const canEquipMore = useMemo(() => {
    const equippedAbilities = abilities.filter((ability) => ability.equipped);
    return equippedAbilities.length < MAX_NUMBER_OF_ABILITIES;
  }, [abilities]);

  return (
    <div>
      {abilities.map((ability) => (
        <RosterAbilityV2
          equipLabel={getEquipLabel({
            equipped: ability.equipped,
            canEquip: canEquipMore,
          })}
          key={ability.localId}
          currentAbility={ability}
          baseAbility={baseStats?.selectedAbilities.find(
            (comparedAbility) =>
              extractLocalAbilityId(ability) ===
              extractLocalAbilityId(comparedAbility)
          )}
          onEquipChange={() => {
            if (ability.localId == null) return;

            const nextEquippedValue = !ability.equipped;

            if (nextEquippedValue && !canEquipMore) {
              showDialog(MaxAbilitiesReached);
              return;
            }

            changeAbility({
              level: ability.level ?? 1,
              equipped: nextEquippedValue,
              abilityId: ability.localId,
            });
          }}
          onLevelChange={(level) => {
            if (ability.localId == null) return;
            changeAbility({
              level,
              equipped: ability.equipped,
              abilityId: ability.localId,
            });
          }}
        />
      ))}
    </div>
  );
};
